module.exports = __webpack_public_path__ + "img/terroir-tinted-2.cf9d264e.jpg";